import React from 'react';
import { compose } from "redux";
import PropTypes from 'prop-types';

import { featureKeys } from 'services/FeatureFlagService';
import workspaceService from 'services/WorkspaceService';
import enhanceWithFeatureFlagSubscription from 'hocs/enhanceWithFeatureFlagSubscription';
import navItems from '../../Workspace/Cohorts/components/CohortNavigation/items.json';

import {
  NavWrapper,
  NavSubTitle,
} from './styles';

import NavBackButton from './NavBackButton';
import NavItem from './NavItem';
import NavHeader from './NavHead';

const Navigation = ({ items, selectedKey, subtitle, backTo, showHeader, getFeatureFlagValue }) => {

  const isRedesignedWorkspace = getFeatureFlagValue(featureKeys.WORKSPACE_REDESIGN);
  const isRedesignedWorkspaceNew = getFeatureFlagValue(featureKeys.BRNT_18710_WORKSPACE_REDESIGN_22);

  // For the navItems, we don't want to clear the selectedWorkspace from the localStorage
  const allowCohortNavigation = navItems.map((nav) => nav.key);

  const isSelectedNavKey = items.find((item) => item.key === selectedKey);
  
  /* Incase if workspace is selected and if we want to select any nav items like 'recent', favorites.. 
   we need to clear selected workspace */
  if(isSelectedNavKey && isRedesignedWorkspaceNew && !allowCohortNavigation.includes(selectedKey)) {
    workspaceService.clearSelectedWorkspace();
  }
  return (
    <NavWrapper newUX={isRedesignedWorkspaceNew}>
      {
        !isRedesignedWorkspace && !isRedesignedWorkspaceNew && showHeader &&
        <NavHeader backTo={backTo}/>
      }
      {(isRedesignedWorkspace || isRedesignedWorkspaceNew) && backTo && <NavBackButton backTo={backTo} />}
      {subtitle && <NavSubTitle>{subtitle}</NavSubTitle> }
      {items && items.map(({ key, icon, text, to }) => (
        <NavItem
          key={key}
          icon={icon}
          text={text}
          to={to}
          active={key === selectedKey}
        />
      ))}
    </NavWrapper>
  );
};

Navigation.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    icon: PropTypes.string,
    text: PropTypes.string,
    key: PropTypes.string,
    to: PropTypes.string,
  })),
  selectedKey: PropTypes.string,
  subtitle: PropTypes.string,
  backTo: PropTypes.string,
  showHeader: PropTypes.bool,
};

const flagNames = [featureKeys.WORKSPACE_REDESIGN, featureKeys.BRNT_18710_WORKSPACE_REDESIGN_22];
export default compose(enhanceWithFeatureFlagSubscription)(Navigation, flagNames);
